import { Action, Reducer } from 'redux';
import { ApplicationState, AppThunkAction, AppThunkActionAsync } from './../../';
import { Task } from "../../Models/TaskManagement/TaskManagementDataModel";
import { ToxnotServiceClient } from '../../ToxnotServiceClient';

// ===============================================================================

//
// State definition
//

export interface StartState {
    isLoading: boolean;
    numSurveysToAnswer: number;
    tasks: Task[];
}

const initialState: StartState = {
    isLoading: true,
    numSurveysToAnswer: 0,
    tasks: []
}

// ===============================================================================

//
// Action definitions
//

const RequestStartData = "REQUEST_START_DATA";
type RequestStartDataType = typeof RequestStartData;

interface RequestStartDataAction {
    type: RequestStartDataType;
}

const ReceiveStartData = "RECEIVE_START_DATA";
type ReceiveStartDataType = typeof ReceiveStartData;

interface ReceiveStartDataAction {
    type: ReceiveStartDataType;
    value: Partial<StartState>;
}


// ===============================================================================


//
// Action creators
//

type KnownAction =
    RequestStartDataAction |
    ReceiveStartDataAction;

export const actionCreators = {
    getStartData: (): AppThunkActionAsync<KnownAction> => async (dispatch, getState) => {
        const applicationState = getState();

        if (!applicationState.startState) {
            return;
        }

        dispatch({ type: RequestStartData });

        const toxnotServiceClient = new ToxnotServiceClient();

        const apiResult = await toxnotServiceClient.getStartData();

        if (!apiResult.success || (apiResult.data === null)) {
            dispatch({
                type: ReceiveStartData,
                value: { numSurveysToAnswer: 0, tasks: [] }
            });
            return;
        }

        dispatch({
            type: ReceiveStartData,
            value: { numSurveysToAnswer: apiResult.data.numSurveysToAnswer, tasks: apiResult.data.tasks }
        });
    }
};

// ===============================================================================

//
// Reducer
//

export const reducer: Reducer<StartState> = (state: StartState | undefined, incomingAction: Action): StartState => {
    if (state === undefined) {
        return initialState
    }

    switch (incomingAction.type) {
        case RequestStartData:
            return {
                ...state,
                isLoading: true,
                numSurveysToAnswer: 0
            };

        case ReceiveStartData:
            const action = incomingAction as ReceiveStartDataAction;
            return {
                ...state,
                ...action.value,
                isLoading: false
            };
    }

    return state;
}
